// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".autocomplete-result.is-active,.autocomplete-result:hover{background-color:#5897fb;color:#fff}", ""]);
// Exports
module.exports = exports;
